import { render, staticRenderFns } from "./FavList.vue?vue&type=template&id=4dbca008&scoped=true&"
import script from "./FavList.vue?vue&type=script&lang=js&"
export * from "./FavList.vue?vue&type=script&lang=js&"
import style0 from "./FavList.vue?vue&type=style&index=0&id=4dbca008&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbca008",
  null
  
)

export default component.exports